module.exports = __webpack_public_path__ + "static/media/code-club.e265d17c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logos/code-club.svg
// module id = 356
// module chunks = 0